import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import { SocialProofMarquee, EditorialMarquee } from "@/components/Marquee";
import About from "@/components/About";
import Services from "@/components/Services";
import Pricing from "@/components/Pricing";
import Portfolio from "@/components/Portfolio";
import SocialShowcase from "@/components/SocialShowcase";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import LeadModal from "@/components/LeadModal";
import FloatingButtons from "@/components/FloatingButtons";

const Home = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <main className="bg-black text-white" data-testid="home-page">
      <Navbar />
      <Hero />
      <SocialProofMarquee />
      <About />
      <EditorialMarquee />
      <Services />
      <Pricing />
      <Portfolio />
      <SocialShowcase />
      <FinalCTA />
      <Footer />
      <LeadModal />
      <FloatingButtons />
    </main>
  );
};

export default Home;
